import React, { forwardRef, lazy, Suspense } from "react";
import { FullPageSpinner } from "../components/common/FullPageSpinner";

const HomeContents = lazy(() => import("./HomeContents"));

export const HomeView = forwardRef((props, ref) => (
   <div id="home-view" className="suspense-wrapper" ref={ref}>
      <Suspense fallback={<FullPageSpinner />}>
         <HomeContents />
      </Suspense>
   </div>
));

export default HomeView;
